import React, { useEffect, useState, Fragment, useRef, useMemo } from 'react';
import { Button, Form, message, Avatar, Spin } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import './SurveyAnswer.less';
import Single from './topics/Single';
import Multiple from './topics/Multiple';
import Fill from './topics/Fill';
import Judge from './topics/Judge';
import Answer from './topics/Answer';
import Region from './topics/Region';
import Sort from './topics/Sort';
import Scale from './topics/Scale';
import MatrixBlanks from './topics/MatrixBlanks';
import Images from './topics/Images';
import Signature from './topics/Signature';
import SelectList from './topics/SelectList';
import logo from '../../../assets/img/survey_logo.png';
import { surveyResultApi, saveSurveyApi, surveyDetailApi, templateDetailApi } from '../api';
import { getCookie, getQueryString } from '../../../utils/utils';
import config from '../../../config';
import dayjs from 'dayjs';
import footerLogo from '../../../assets/img/footer_logo_black.png';
import { getVisibleQuestionList, getVisibleFormFieldNames } from '../utils/getVisibleQuestionList';

let noSelect = ['1986', '1987', '1990', '1992', '1993'];

const SurveyAnswer: React.FC = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [form] = Form.useForm();
    const [dataList, setDataList] = useState([]);
    const [name, setName] = useState('');
    const [directions, setDirections] = useState('');
    const [isMount, setIsMount] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formValue, setFormValue] = useState(null);
    const dataListRef = useRef<any>();
    const [notValitator, setNotValitator] = useState<any>([]);

    const [initForm, setInitForm] = useState(null);

    const getCurrentVisibleList = () => {
        const values = form.getFieldsValue();
        return getVisibleQuestionList(dataListRef.current || dataList, values);
    };

    const getSubmittableFormValues = () => {
        const allValues = form.getFieldsValue();
        const visibleFieldNames = new Set(getVisibleFormFieldNames(getCurrentVisibleList()));
        return Object.keys(allValues).reduce(
            (result, key) => {
                if (visibleFieldNames.has(key)) {
                    result[key] = allValues[key];
                }
                return result;
            },
            {} as Record<string, any>,
        );
    };

    const sumit = () => {
        console.log(form.getFieldsValue());
        // 文件收集，不合法数据清空表单记录
        let filedKeys = Object.keys(form.getFieldsValue());
        let keys = filedKeys.filter(key => key.includes('-11'));
        if (keys && keys.length) {
            keys.forEach(item => {
                let value = form.getFieldValue(item);
                if (value && !Array.isArray(value)) {
                    form.setFieldValue(item, null);
                }
            });
        }

        if (!validatorFill()) {
            // 不传参数验证所有已注册字段（可见题目的 Form.Item 均已挂载）
            form.validateFields().catch(() => {});
            scrollForm();
            return message.error('请将必答题或未填写完成的题目作答完成');
        }
        // 不传参数验证所有已注册字段，避免 NamePath 不匹配导致验证被跳过
        form.validateFields()
            .then(() => {
                save();
            })
            .catch(() => {
                scrollForm();
                message.error('请将必答题或未填写完成的题目作答完成');
            });
    };

    // 表单校验滚动
    const scrollForm = () => {
        let timer = setTimeout(() => {
            const errorList = (document as any).querySelectorAll('.ant-form-item-has-error');
            errorList[0]?.scrollIntoView({
                block: 'center',
                behavior: 'smooth',
            });
            clearTimeout(timer);
        }, 100);
    };

    // 多项填空、矩阵填空输入必填校验
    const validatorFill = () => {
        let notArr: any = [];
        if (dataListRef.current) {
            let keysArr = Object.keys(form.getFieldsValue());
            let list = dataListRef.current;
            const visibleIds = new Set(getCurrentVisibleList().map((item: any) => Number(item.id)));
            keysArr.forEach((topic: string) => {
                let topicArr = topic.split('-');
                let topicId = topicArr[0];
                let topicType = topicArr[1];

                if (!visibleIds.has(Number(topicId))) {
                    return;
                }

                let currentTopic = list.filter((it: any) => Number(it.id) === Number(topicId));

                if ((topicType === '10' || topicType === '5') && currentTopic && currentTopic.length && currentTopic[0].required) {
                    if (!form.getFieldsValue()[topic]) {
                        notArr.push(Number(topicId));
                    }
                    // 多项填空
                    if (form.getFieldsValue()[topic] && form.getFieldsValue()[topic].length && topicType === '5') {
                        let isInput = form.getFieldsValue()[topic].filter((it: any) => !it);
                        if (isInput && isInput.length) {
                            notArr.push(Number(topicId));
                        }
                    }
                    // 矩阵填空 - 校验存在一行有效数据即完成
                    if (form.getFieldsValue()[topic] && form.getFieldsValue()[topic].length && topicType === '10' && currentTopic[0].optionList) {
                        let title = currentTopic[0].optionList[0].content ? JSON.parse(currentTopic[0].optionList[0].content) : null;
                        let row, col;
                        let answers = form.getFieldsValue()[topic];
                        let isExist = false;
                        if (title) {
                            row = title[0].length;
                            col = title[1].length;
                            for (let i = 0; i < col; i++) {
                                let res = answers.slice(i * row, (i + 1) * row).every((it: any) => it);
                                if (res) {
                                    isExist = true;
                                    break;
                                }
                            }
                        }
                        console.log(isExist);
                        if (!isExist) {
                            notArr.push(Number(topicId));
                        }
                    }
                } else if (topicType === '5' && currentTopic && currentTopic.length && !currentTopic[0].required) {
                    if (form.getFieldsValue()[topic] && form.getFieldsValue()[topic].length) {
                        let isExistInput = form.getFieldsValue()[topic].filter((it: any) => it);
                        let isInput = form.getFieldsValue()[topic].filter((it: any) => !it);

                        if (isExistInput && isExistInput.length && isInput && isInput.length) {
                            notArr.push(Number(topicId));
                        }
                    }
                }
            });
        }
        if (notArr.length) {
            setNotValitator(notArr);
            return false;
        }
        return true;
    };

    // 校验不合法上传文件题型
    const checkFileAnswer = (answerArr: any) => {
        let isCheck = false;
        if (answerArr) {
            if (Array.isArray(answerArr) && answerArr.length) {
                let exist = answerArr.every(file => file.url);
                if (exist) {
                    isCheck = false;
                } else {
                    isCheck = true;
                }
            } else {
                isCheck = true;
            }
        }
        return isCheck;
    };

    // 保存问卷答案
    const save = async () => {
        let paramApi: any = {
            answersheetId: localStorage.getItem('answersheetId'),
            id: params.id,
            questions: [],
            startedAt: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            channelId: localStorage.getItem('channelId') || undefined,
        };
        let valueList = getSubmittableFormValues();
        console.log(valueList);
        let keyList = Object.keys(valueList);
        keyList.forEach(topic => {
            let option = dealOptions(topic, valueList);
            paramApi.questions.push(option);
        });
        setLoading(true);

        const res: any = await saveSurveyApi(paramApi);
        setLoading(false);
        console.log('提交成功', paramApi);
        if (res && res.status_code === 200) {
            const channelId = localStorage.getItem('channelId');
            const empid = localStorage.getItem('empid');

            localStorage.removeItem('formData');
            localStorage.removeItem('initFormData');
            localStorage.removeItem('surveyId');
            localStorage.removeItem('sessionId');
            localStorage.removeItem('answersheetId');
            localStorage.removeItem('channelId');
            localStorage.removeItem('surveyList');
            localStorage.removeItem('surveyListTime');
            localStorage.removeItem('empid');

            // QT 埋点
            // 控件点击：医调研-问卷提交
            if ((window as any)?.aplus_queue?.push) {
                const cusp: {
                    survey_id: number;
                    survey_title: string;
                    chid?: number;
                    empid?: number;
                    source?: string;
                } = {
                    survey_id: Number(params.id),
                    survey_title: name,
                };
                if (channelId) {
                    cusp.chid = Number(channelId);
                }
                if (empid) {
                    cusp.empid = Number(empid);
                }
                if (getQueryString('source')) {
                    cusp.source = getQueryString('source') || '';
                }
                (window as any).aplus_queue.push({
                    action: 'aplus.record',
                    arguments: ['survey_click_btn_submit', 'CLK', cusp],
                });
            } else {
                console.error('aplus_queue 对象未定义');
            }

            // 问卷2010 - 题目选项跳转
            if (params?.id === '2010') {
                const selectTopic = paramApi.questions.find((item: any) => parseInt(item.id) === 12110);
                const selectOptionId = parseInt(selectTopic.options[0].id);
                if (selectOptionId === 30874) {
                    return (window.location.href = 'https://wj.cn-healthcare.com/s/1986');
                }
                if (selectOptionId === 30875) {
                    return (window.location.href = 'https://wj.cn-healthcare.com/s/1987');
                }
                if (selectOptionId === 30876) {
                    return (window.location.href = 'https://wj.cn-healthcare.com/s/1990');
                }
                if (selectOptionId === 30877) {
                    return (window.location.href = 'https://wj.cn-healthcare.com/s/1992');
                }
                if (selectOptionId === 30878) {
                    return (window.location.href = 'https://wj.cn-healthcare.com/s/1993');
                }
            } else {
                navigate(`/s/${params.id}/result`, { replace: true });
            }
        } else {
        }
    };

    // 处理各种题型答案提交
    const dealOptions = (topic: string, valueList: any) => {
        let topicArr = topic.split('-');
        let topicId = topicArr[0];
        let topicType = topicArr[1];
        let option;
        // 单选
        if (topicType === '1') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                options: [
                    {
                        answer: valueList[topic] && valueList[topic].length && valueList[topic][1] ? valueList[topic][1] : null,
                        id: valueList[topic] && valueList[topic].length ? valueList[topic][0] : '',
                    },
                ],
            };
        }
        // 判断
        if (topicType === '3') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                options: [
                    {
                        answer: null,
                        id: valueList[topic],
                    },
                ],
            };
        }
        // 多选
        if (topicType === '2') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                options: getAnswerOption('2', valueList[topic], topicId),
            };
        }
        // 填空题（单项、多项）
        if (topicType === '4' || topicType === '5' || topicType === '10' || topicType === '12') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                options: [
                    {
                        answer: getFillAnswer(valueList[topic]),
                        id: '',
                    },
                ],
            };
        }
        // 问答
        if (topicType === '6') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                attachment: fileDeal(valueList[topic]?.file?.fileList),
                options: getAnswerOption('6', valueList[topic]),
            };
        }
        // 地区
        if (topicType === '7') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                options: [
                    {
                        answer: valueList[topic] ? JSON.stringify(valueList[topic]) : valueList[topic],
                        id: '',
                    },
                ],
            };
        }
        // 量表题
        if (topicType === '8') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                options: [
                    {
                        answer: null,
                        id: valueList[topic],
                    },
                ],
            };
        }
        // 排序
        if (topicType === '9') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                options: getAnswerOption('9', valueList[topic], topicId),
            };
        }
        // 文件收集
        if (topicType === '11') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                options: [
                    {
                        answer: valueList[topic] ? getFileAnswer(valueList[topic]) : null,
                        id: '',
                    },
                ],
            };
        }
        // 下拉选择
        if (topicType === '13') {
            if (Array.isArray(valueList[topic])) {
                option = {
                    id: topicId,
                    questionTypeId: topicType,
                    options: getAnswerOption('13', valueList[topic], topicId),
                };
            } else {
                option = {
                    id: topicId,
                    questionTypeId: topicType,
                    options: [
                        {
                            answer: null,
                            id: valueList[topic],
                        },
                    ],
                };
            }
        }
        return option;
    };

    // 处理不合法上传文件
    const getFileAnswer = (answerArr: any) => {
        if (answerArr && Array.isArray(answerArr) && answerArr.length) {
            return JSON.stringify(answerArr);
        }
        return null;
    };

    // 处理填空题未作答null
    const getFillAnswer = (values: any) => {
        const isNull = values && values.length ? values.filter((it: any) => it) : [];
        if (isNull && isNull.length) {
            return JSON.stringify(values);
        }
        return null;
    };

    // 处理矩阵填空作答
    const getMatrixAnswer = (values: any) => {
        const isNull = values && values.length ? values.filter((it: any) => it) : [];
        if (isNull && isNull.length) {
            let arr = [...values];
            arr.pop();
            return JSON.stringify(arr);
        }
        return null;
    };

    // 处理多项填空作答提交
    const getMultipleAnswer = (id: string) => {
        let inputEle: any = document.querySelectorAll(`.multipleFill${id}`);
        let arr: any = [];
        if (inputEle.length) {
            inputEle.forEach((el: any) => {
                arr.push(el.value);
            });
            return JSON.stringify(arr);
        }
        return null;
    };

    // 多选展示规则显示
    const getShowMultiTitle = (item: any) => {
        if (item.minSelect && !item.maxSelect) {
            return `最少选择${item.minSelect}项`;
        }
        if (!item.minSelect && item.maxSelect) {
            return `最多选择${item.maxSelect}项`;
        }
        if (item.minSelect && item.maxSelect && item.minSelect !== item.maxSelect) {
            return `最少选择${item.minSelect}项，最多选择${item.maxSelect}项`;
        }
        if (item.minSelect && item.maxSelect && item.minSelect === item.maxSelect) {
            return `选择${item.minSelect}项`;
        }
        return '';
    };

    // 题目分析语
    const getShowTitleAnalysis = (item: any) => {
        switch (item.questionTypeId) {
            case 2:
                return getShowMultiTitle(item);
            case 9:
                return '按期望顺序依次点击所有选项';
            case 11:
                return '最多上传10个文件';
            case 12:
                return '请确保签名笔画清晰';
            case 13:
                return getShowMultiTitle(item);
            default:
                return null;
        }
    };

    const fileDeal = (fileList: any) => {
        let arr: string[] = [];
        if (fileList && fileList.length) {
            fileList.forEach((file: any) => {
                if (file.url) {
                    arr.push(file.url);
                }
            });
        }
        return arr;
    };

    // 答案选项提交处理
    const getAnswerOption = (type: string, answer: any, topId?: any) => {
        let options: any = [];
        if (type === '6') {
            options.push({
                id: '',
                answer: answer?.text,
            });
        }
        if (type === '2') {
            if (answer && answer.length) {
                if (answer[0] && answer[0].length) {
                    answer[0].forEach((item: any) => {
                        options.push({
                            id: item,
                            answer: dealOtherOption(topId, item) ? answer[1] : null,
                        });
                    });
                }
            }
        }
        if (type === '9' || type === '13') {
            if (answer && answer.length) {
                answer.forEach((item: any) => {
                    options.push({
                        id: item,
                        answer: null,
                    });
                });
            }
        }
        return options;
    };

    // 处理选择题 - 其它选项输入内容
    const dealOtherOption = (topId: any, optionId: any) => {
        if (dataListRef.current) {
            let currentTopic = dataListRef.current.filter((item: any) => item.id === Number(topId));
            if (currentTopic && currentTopic.length && currentTopic[0].optionList && currentTopic[0].optionList.length) {
                let option = currentTopic[0].optionList.filter((item: any) => item.id === Number(optionId));
                if (option && option.length && option[0].isBlank) {
                    return true;
                }
                return false;
            }
            return false;
        }
        return false;
    };

    // 获取题目类型
    const getTag = (type: number) => {
        switch (type) {
            case 1:
                return '单选题';
            case 2:
                return '多选题';
            case 3:
                return '判断题';
            case 4:
                return '单项填空';
            case 5:
                return '多项填空';
            case 6:
                return '问答题';
            case 7:
                return '地区题';
            case 8:
                return '量表题';
            case 9:
                return '排序题';
            case 10:
                return '矩阵填空';
            case 11:
                return '文件收集';
            case 12:
                return '电子签名';
            case 13:
                return '选择列表';
            default:
                return;
        }
    };

    // 题目组件渲染
    const getTemp = (item: any, index: number) => {
        switch (item.questionTypeId) {
            case 1:
                return <Single {...item} num={index} form={form} initForm={initForm} />;
            case 2:
                return <Multiple {...item} num={index} form={form} initForm={initForm} />;
            case 3:
                return <Judge {...item} num={index} form={form} setDataList={setDataList} dataList={dataList} dataListRef={dataListRef.current} initForm={initForm} />;
            case 4:
                return <Fill {...item} num={index} form={form} />;
            case 5:
                return <Fill {...item} num={index} form={form} notValitator={notValitator} />;
            case 6:
                return <Answer {...item} num={index} form={form} />;
            case 7:
                return <Region {...item} num={index} form={form} />;
            case 8:
                return <Scale {...item} num={index} form={form} setDataList={setDataList} dataList={dataList} dataListRef={dataListRef.current} initForm={initForm} />;
            case 9:
                return <Sort {...item} num={index} form={form} />;
            case 10:
                return <MatrixBlanks {...item} num={index} form={form} formValue={formValue} notValitator={notValitator} />;
            case 11:
                return <Images {...item} num={index} form={form} notValitator={notValitator} />;
            case 12:
                return <Signature {...item} num={index} form={form} />;
            case 13:
                return <SelectList {...item} num={index} form={form} />;
            default:
                return null;
        }
    };

    // 获取问卷详情
    const getSurveyDetails = async () => {
        if (!params?.id) return;
        const res: any = await surveyDetailApi({ id: params.id });
        if (res && res.status_code === 200) {
            document.title = res.data.name || '医调研';
            if (res.data.status === 2 && getQueryString('type') !== '1') {
                message.error('该问卷已下架，感谢您的参与。');
                navigate(`/s/error?type=${2}`, { replace: true });
                return;
            }
            setName(res.data.name);
            setDirections(res.data.directions);
            if (res.data.questionList && res.data.questionList.length) {
                setDataList(res.data.questionList);
                dataListRef.current = res.data.questionList;
            }
            getCover(res);
            setIsMount(true);
            if (res.data.status === 0 && getQueryString('type') !== '1') {
                message.error('问卷未发布，无法访问');
                navigate(`/s/${params.id}`);
                return;
            }
            if (res.data.isNeedLogin && (!getCookie('memToken') || !getCookie('authentication_member_card')) && getQueryString('type') !== '1') {
                navigate(`/s/${params.id}`);
            }

            // 问卷有变动 || 缓存数据不等于当前问卷，清除缓存
            const localCacheTime = localStorage.getItem('surveyListTime') ? Number(localStorage.getItem('surveyListTime')) : 0;
            const equalSurveyId = localStorage.getItem('surveyId') !== params.id;
            const cacheTime = res.data.cacheDate ? new Date(res.data.cacheDate).getTime() : 0;
            if (cacheTime > localCacheTime || equalSurveyId) {
                localStorage.removeItem('formData');
                localStorage.removeItem('initFormData');
                localStorage.removeItem('surveyId');
                localStorage.removeItem('surveyList');
                localStorage.removeItem('surveyListTime');
            }
        }
    };

    // 获取模板预览详情
    const getTemplateDetail = async () => {
        if (!params?.id) return;
        const res: any = await templateDetailApi({ id: params.id });
        if (res && res.status_code === 200) {
            setName(res.data.name);
            setDirections(res.data.directions);
            if (res.data.questionList && res.data.questionList.length) {
                setDataList(res.data.questionList);
            }
            getCover(res);
        }
    };

    // 设置封面图
    const getCover = (res: any) => {
        const survey: any = document.getElementsByClassName('survey-answer')[0];
        if (window.innerWidth > 750) {
            survey.style.backgroundImage = res.data.webHeaderCover ? `url(${res.data.webHeaderCover})` : '';
        } else {
            survey.style.backgroundImage = res.data.h5HeaderCover ? `url(${res.data.h5HeaderCover})` : '';
        }

        const isPreview = getQueryString('type') || getQueryString('template');
        if (isPreview || params?.sid) {
            survey.style.backgroundPosition = 'center top';
        }
    };

    // 继续作答 - 未提交答案回显
    const initFormData = () => {
        const formData = localStorage.getItem('initFormData');
        if (formData) {
            const parsed = JSON.parse(formData);
            form.setFieldsValue(parsed);
            setFormValue(parsed);
        }
    };

    // 监听表单变化，本地缓存表单内容
    const onValuesChange = (value: any, allValue: any) => {
        console.log('表单变化：', value);

        // 暂存当前change的题目
        const keys = Object.keys(value);
        if (keys && keys.length) {
            localStorage.setItem('currentChangeTopic', keys[0].split('-')[0]);
        }

        const isPreview = getQueryString('type') || getQueryString('template');
        if (!params?.sid && !isPreview) {
            setFormValue(form.getFieldsValue());
            localStorage.setItem('formData', JSON.stringify(form.getFieldsValue()));

            if (params?.id) {
                localStorage.setItem('surveyId', params?.id);
            }

            let formData: any = localStorage.getItem('formData');
            let current = Object.keys(value)[0];

            let oldVal: any = initForm;
            let newVal = JSON.parse(formData);

            oldVal[current] = newVal[current];
            localStorage.setItem('initFormData', JSON.stringify(oldVal));
            setInitForm({ ...oldVal });
        }
    };

    // 获取问卷详情 - 答案回显
    const getSurveyResult = async () => {
        const res: any = await surveyResultApi({ id: params.id });
        if (res && res.status_code === 200) {
            setName(res.data.name);
            setDirections(res.data.directions);
            if (res.data.questionList && res.data.questionList.length) {
                setDataList(res.data.questionList);
            }
            getCover(res);
        }
    };

    // 附件参数回显
    const getFileList = (attachment: string[]) => {
        if (attachment && attachment.length) {
            const arr = attachment.map((it: string) => ({ url: it }));
            return arr;
        }
        return [];
    };

    // 获取答案内容回显表单
    const getAnswerContent = (item: any) => {
        let answer: any;
        if (item.questionTypeId === 1) {
            answer = [];
            let arr = item.optionList && item.optionList.length && item.optionList.filter((it: any) => it.selected);
            answer[0] = arr && arr.length ? arr[0].id : '';
            answer[1] = arr && arr.length ? arr[0].exContent : '';
        }
        if (item.questionTypeId === 2) {
            let arr = item.optionList && item.optionList.length && item.optionList.filter((it: any) => it.selected);
            answer = [];
            answer[0] = [];
            if (arr && arr.length) {
                arr.forEach((el: any) => {
                    answer[0].push(el.id);
                    answer[1] = el.exContent;
                });
            }
        }
        if (item.questionTypeId === 3 || item.questionTypeId === 8) {
            let arr = item.optionList && item.optionList.length && item.optionList.filter((it: any) => it.selected);
            if (arr && arr.length) {
                answer = arr[0].id;
            }
        }
        if (item.questionTypeId === 4 || item.questionTypeId === 5) {
            if (item.optionList && item.optionList.length) {
                item.optionList.forEach((el: any) => {
                    answer = el.content ? JSON.parse(el.content) : [];
                });
            }
        }
        if (item.questionTypeId === 6) {
            answer = {};
            if (item.optionList && item.optionList.length) {
                item.optionList.forEach((el: any) => {
                    answer.text = el.content;
                    answer.file = getFileList(item.attachment);
                });
            }
        }
        if (item.questionTypeId === 9) {
            let arr = item.optionList && item.optionList.length && item.optionList.filter((it: any) => it.selected);
            answer = [];
            if (arr && arr.length) {
                arr.forEach((el: any) => {
                    answer.push(el.id);
                });
            }
        }
        if (item.questionTypeId === 10) {
            if (item.optionList && item.optionList.length) {
                item.optionList.forEach((el: any) => {
                    answer = el.exContent ? JSON.parse(el.exContent) : [];
                });
            }
        }
        if (item.questionTypeId === 11) {
            if (item.optionList && item.optionList.length) {
                item.optionList.forEach((el: any) => {
                    answer = el.content ? JSON.parse(el.content) : [];
                });
            }
        }
        if (item.questionTypeId === 12) {
            if (item.optionList && item.optionList.length) {
                item.optionList.forEach((el: any) => {
                    answer = el.content ? JSON.parse(el.content) : [];
                });
            }
        }
        return answer;
    };

    const getAvatar = () => {
        const reg = new RegExp(config.FILE_URL_PREFIX || '');
        const url = getCookie('memHeadImg');
        let result = '';
        if (url) {
            result = url.replace(reg, '');
        }
        return config.FILE_URL_PREFIX + '/' + result;
    };

    // 刷新页面 - 清除缓存
    const beforeunload = () => {
        localStorage.removeItem('formData');
        localStorage.removeItem('surveyId');
    };

    // 问卷答案回显
    useEffect(() => {
        if (params.sid && dataList && dataList.length) {
            let values: any = {};
            dataList.forEach((item: any) => {
                let key = `${item.id}-${item.questionTypeId}`;
                if (item.questionTypeId !== 7) {
                    values[key] = getAnswerContent(item);
                    // form.setFieldValue(key, getAnswerContent(item));
                }

                // 多项填空答案回显
                if (item.questionTypeId === 5 && item.optionList.length && item.optionList[0].content) {
                    let timer = setTimeout(() => {
                        let result = JSON.parse(item.optionList[0].content);
                        let inputEle: any = document.querySelectorAll(`.multipleFill${item.id}`);
                        if (inputEle.length) {
                            inputEle.forEach((el: any, index: number) => {
                                el.value = result[index];
                            });
                        }
                        clearTimeout(timer);
                    }, 500);
                }
            });
            form.setFieldsValue(values);
            setFormValue(values);
        }
    }, [dataList]);

    useEffect(() => {
        // 没有问答记录id、返回封面(不考虑预览、详情)
        const isPreview = getQueryString('type') || getQueryString('template');
        if (!localStorage.getItem('answersheetId') && !params.sid && !isPreview) {
            navigate(`/s/${params.id}`);
            return;
        }
        if (params.sid && params.id) {
            getSurveyResult();
        } else if (getQueryString('type') === '2') {
            getTemplateDetail();
        } else {
            getSurveyDetails();
        }

        if (!isPreview) {
            initFormData();
        }

        // window.addEventListener('beforeunload', beforeunload);

        // return ()=>{
        //     window.removeEventListener("beforeunload", beforeunload);
        // }
    }, []);

    // 初始化表单缓存 - 用于选项逻辑切换回显
    useEffect(() => {
        if (dataListRef.current) {
            const localInitFormData = localStorage.getItem('initFormData');
            const isPreview = getQueryString('type') || getQueryString('template');
            if (localInitFormData && !isPreview) {
                const local = JSON.parse(localInitFormData);
                setInitForm({ ...local });
                setFormValue(local);
            } else {
                localStorage.setItem('initFormData', JSON.stringify(form.getFieldsValue()));
                setInitForm(form.getFieldsValue());
            }
        }
    }, [dataListRef.current]);

    const newDataList = useMemo(() => {
        if (!dataList?.length) {
            return [];
        }

        const values = formValue ?? form.getFieldsValue() ?? {};
        const visibleList = getVisibleQuestionList(dataList, values);

        const isPreview = getQueryString('type') || getQueryString('template');
        if (!isPreview && params?.id) {
            localStorage.setItem('surveyList', JSON.stringify(visibleList));
            localStorage.setItem('surveyListTime', String(new Date().getTime()));
        }

        return visibleList;
    }, [dataList, formValue, params?.id]);

    return (
        <>
            {!getQueryString('type') && !getQueryString('template') && !params.sid ? (
                <div className="survey-header">
                    <div className="survey-logo">
                        <img src={logo} alt="" />
                    </div>
                    {getCookie('memToken') && getCookie('authentication_member_card') ? (
                        <div className="user-wrap">
                            <Avatar size="large" src={getAvatar()} />
                            <div className="user-info">
                                <p>{getCookie('memNickname')}</p>
                            </div>
                        </div>
                    ) : null}
                </div>
            ) : null}
            <div className={`survey-answer ${params.id && noSelect.includes(params.id) && 'no-select'}`}>
                <div className={`survey-content`}>
                    <p className="title" dangerouslySetInnerHTML={{ __html: name }}></p>
                    <div className="description">{<p dangerouslySetInnerHTML={{ __html: directions }}></p>}</div>
                    <div className="examination">
                        <Form form={form} layout="vertical" autoComplete="off" onValuesChange={onValuesChange}>
                            {newDataList && newDataList.length
                                ? newDataList.map((item: any, index: number) => (
                                      <div className="examination-item" key={index}>
                                          <div className="examination-tag_container">
                                              <p className="examination-tag">{getTag(item.questionTypeId)}</p>
                                              <span className="examination-tag_tip">
                                                  {item.questionTypeId === 13 && item.isMultipleChoice ? <span className="select-multiple-tag">（多选）</span> : null}
                                                  {getShowTitleAnalysis(item)}
                                              </span>
                                          </div>
                                          {getTemp(item, index + 1)}
                                      </div>
                                  ))
                                : null}
                        </Form>
                    </div>
                    {isMount && !params?.sid && !getQueryString('type') && !getQueryString('template') ? (
                        <div className="sumit">
                            <Spin spinning={loading}>
                                <Button type="primary" block onClick={sumit}>
                                    提交
                                </Button>
                            </Spin>
                        </div>
                    ) : null}
                </div>
                <div className="survey-footer-wrap">
                    <div className="survey-footer">
                        <img src={footerLogo} alt="" />
                        <p className="footer-text">
                            <span>健康界 版权所有 All Rights Reserved.</span>
                            <span>北京华媒康讯信息技术股份有限公司</span>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SurveyAnswer;
